import { getGASesionId } from 'services/metrics/shared/getSessionId';
import { getRegion } from 'utils/Region';
import Utils from 'utils/Utils';

export const METRICS = {
  EXECUTOR: 'executor',
  EVENT: {
    LOGIN: 'Login',
  },
  CATEGORY: {
    LANDING: 'landing',
  },
  ACTION: {
    LOGIN: 'inicia sesion',
  },
  LABEL: {
    SING_UP: 'registrate',
    LOG_IN: 'inicia sesion',
    FREE_WATCH: 'ver gratis',

    LOGIN_NEXT: ' - siguiente',
    LOGIN_CANCEL: ' - cancelar',
    LOGIN_PASSWORD_NEXT: ' - ingresar contraseña - siguiente',
    LOGIN_PASSWORD_CANCEL: ' - ingresar contraseña - cancelar',
    LOGIN_SUCCESS: 'exitoso - ',
    LOGIN_FACEBOOK: 'continua con facebook',
    LOGIN_APPLE: 'continua con apple',

    OPERATOR_RESEND: 'operadora - reenviar codigo',
    OPERATOR_NEXT: 'operadora - codigo - siguiente',
    OPERATOR_CANCEL: 'operadora - codigo - cancelar',

    FORGET_PASSWORD: 'olvidaste tu contraseña',
    FORGET_PASSWORD_GET: 'olvidaste tu contraseña - obtener contraseña',
    FORGET_PASSWORD_CANCEL: 'olvidaste tu contraseña - cancelar',
    FORGET_PASSWORD_SUCCESS: 'olvidaste tu contraseña - entendido',

    SSO: 'obtener codigo',
    SSO_NEXT: 'codigo de acceso - siguiente',
    SSO_CANCEL: 'codigo de acceso - cancelar',
  },
};

export const TYPES_LOGIN = {
  EMAIL: 'correo',
  OPERATOR: 'operadora',
  APPLE_ID: 'apple id',
  FACEBOOK: 'facebook',
  AUTO_LOGIN: 'autologin',
};

export const DEFAULTS_FORGOTTEN_PASSWORD_METRIC = {
  event: 'interaction_forgotten_password',
  client_id: 'no aplica',
  user_id: 'no aplica',
  parent_id: 'no aplica',
  user_id_custom: 'no aplica',
  client_id_custom: 'no aplica',
  sign_up_method: 'no aplica',
  user_type: 'anonimo',
  timestamp_micros: 'no aplica',
  suscriptions: 'no aplica',
  page_path: 'login',
  page_title: 'inicia sesion',
  page_url: `no aplica`,
  previous_path: 'landing',
  content_section: 'no aplica',
  content_subsection: 'no aplica',
  device: 'web',
  os_version: 'web',
  country: Utils.getAbbreviation(getRegion()),
  engagement_time_msec: 0,
  session_id: getGASesionId(),
  interaction_type: '',
};
